<div class="loginWrapper">
    <aside>
        @switch (visibleFragment) {
            @case (FormFragmentsEnum.FORGOT_PASSWORD) {
                <div class="formContainer">
                    <ng-container *ngTemplateOutlet="logos" />
                    <h2>{{ 'forgotPassword.recoverPassword' | translate }}</h2>
                    <app-forgot-password-form />
                </div>
            }

            @case (FormFragmentsEnum.RESET_PASSWORD) {
                <div class="formContainer">
                    <ng-container *ngTemplateOutlet="logos" />
                    <h2>{{ 'forgotPassword.resetPassword' | translate }}</h2>
                    <app-reset-password-form />
                </div>
            }

            @case (FormFragmentsEnum.CHANGE_PASSWORD) {
                <div class="formContainer">
                    <ng-container *ngTemplateOutlet="logos" />
                    <h2>{{ 'generalKeywords.changePassword' | translate }}</h2>
                    <app-require-password-change (isLoggedIn)="navigateToHome($event)" />
                </div>
            }

            @default {
                <div class="formContainer">
                    <ng-container *ngTemplateOutlet="logos" />
                    <h2>{{ 'generalKeywords.signin' | translate }}</h2>
                    <h3>{{ 'generalKeywords.signinText' | translate }}</h3>
                    <app-login-form (isLoggedIn)="navigateToHome($event)" />
                </div>
            }
        }
    </aside>
    <div class="main">
        <img [src]="IMAGES.LOGIN_HERO_2_JPG" alt="Login" class="hero-image" />
    </div>
</div>

<ng-template #logos>
    <div class="logoContainer">
        <img [ngSrc]="IMAGES.LOGOS.SHIJI_LOGO_BLUE0_SVG" alt="Shiji Logo" width="322" height="60" priority />
        <img [ngSrc]="IMAGES.LOGOS.ICEPORTAL_CONTENT_LOGO_VERTICAL_SVG" alt="IcePortal Content Logo" width="322" height="50" priority />
    </div>
</ng-template>
